import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';

import { Box, Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import PhotoCamera from '@material-ui/icons/PhotoCamera';

import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'axios';
import RefreshToken from '../../../partials/RefreshToken';
import { AuthContext } from '../../../../@jumbo/components/context/AuthContext';
import { useSnackbar } from 'notistack';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  imgStyle: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: '100%',
    maxWidth: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  selectStyle: {
    [`& fieldset`]: {
      borderRadius: 25,
    },
    [`& .MuiSelect-outlined`]: {
      borderRadius: 25,
    },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const RequirementAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const [id, setId] = useState('');

  const [title, setTitle] = useState('');
  const [requirementDocument, setRequirementDocument] = useState('');
  const [status, setStatus] = useState(false);
  const [label, setLabel] = useState('');
  const [type, setType] = useState('');
  const [requirementRequiredFields, setRequirementRequiredFields] = useState([]);

  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  const [message, setMessage] = useState('There is no data');

  console.log('editForm', editForm);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const clearStates = () => {
    setId('');
    setTitle('');
    setRequirementDocument('');
    setStatus(false);
    setEditObj({});

    // setCode('');
    // setCurrency('');
    // setContinent('');
    // setPhone('');
    // setStatus(false);
    // setEditObj({});
  };

  const validation = () => {
    // let isError = false;
    // if (!name.trim()) {
    //   console.log('name');
    //   handleSnakbarOpen('Please enter name', 'error');
    //   document.getElementById('name').focus();
    //   return (isError = true);
    // }
    // if (!code.trim()) {
    //   handleSnakbarOpen('Please enter code', 'error');
    //   document.getElementById('code').focus();
    //   return (isError = true);
    // }
    // if (!currency.trim()) {
    //   console.log('currency');
    //   handleSnakbarOpen('Please enter currency', 'error');
    //   document.getElementById('currency').focus();
    //   return (isError = true);
    // }
    // if (!continent.trim()) {
    //   console.log('continent');
    //   handleSnakbarOpen('Please enter continent', 'error');
    //   document.getElementById('continent').focus();
    //   return (isError = true);
    // }
    // if (!phone.trim()) {
    //   console.log('phone');
    //   handleSnakbarOpen('Please enter phone number', 'error');
    //   document.getElementById('phone').focus();
    //   return (isError = true);
    // }
    // console.log('finish');
    // return isError;
  };

  const onSubmit = async e => {
    // return console.log('image file', imageFile)
    e.preventDefault();
    let err = validation();
    console.log('err', err);
    if (err) {
      return;
    } else {
      console.log('onSubmit');
      console.log('editIndexNo', editIndexNo);
      e.preventDefault();
      setLoading(true);
      let response;
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);

      let formData = {
        title,
        requirementDocument,
        status,
        requirementRequiredFields,
      };
      // return console.log('data', formData);
      try {
        if (addForm) {
          response = await axios({
            url: `/api/v1/private/requirement`,
            method: 'post',
            data: formData,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setList([...list, response.data.data]);

          console.log('addForm response', response);
        } else if (editForm) {
          response = await axios({
            url: `/api/v1/private/requirement/${id}`,
            method: 'put',
            data: formData,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('editForm response', response);

          list[editIndexNo] = response.data.data;
          setRefresh(!refresh);
        }

        closeAddDialog();
        activeAddForm();
        handleSnakbarOpen(response.data.message, 'success');
      } catch (error) {
        console.log('error', error);
        console.log('errorresponse', error.response);

        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
        setLoading(false);
      }
      setLoading(false);
    }
    // handleSnakbarOpen()
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  const handleKey = text => {
    let trim = text.trim();
    let lower = trim.toLowerCase();
    return lower.replaceAll(' ', '_');
  };

  const handleAdd = () => {
    let key = handleKey(label);
    let minLen = 2;
    let maxLen = 64;
    if (type === 'image') {
      minLen = 0;
      maxLen = 0;
    }
    if (label && type) {
      let obj = { label, type, key, minLen, maxLen };
      setRequirementRequiredFields([...requirementRequiredFields, obj]);
      setLabel('');
      setType('');
    }
  };

  const deleteOne = e => {
    let items = requirementRequiredFields.filter(item => item.label != e);
    setRequirementRequiredFields(items);
  };

  useEffect(() => {
    console.log('loading edit data', editObj);

    if (editObj.id) {
      console.log('loading edit data 2');

      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setTitle(editObj.title);
      setRequirementDocument(editObj.requirementDocument);
      setStatus(editObj.status);
      setRequirementRequiredFields(editObj.requirementRequiredFields);
    }
  }, [editObj]);

  const activeAddForm = () => {
    clearStates();
  };

  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);
  return (
    <React.Fragment>
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Requirement' : 'Add Requirement'}
        </Typography>
      </div>

      <TextField
        id="title"
        label="Title"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={title}
        onChange={e => setTitle(e.target.value)}
      />

      <TextField
        variant="outlined"
        select
        label="Requirement Document"
        size="small"
        fullWidth
        required
        value={requirementDocument}
        onChange={e => setRequirementDocument(e.target.value)}
        className={`${classes.marginStyle} ${classes.inputStyle}`}>
        <MenuItem value="Passport_Verification">Passport Verification</MenuItem>
        <MenuItem value="Driving_Licence_Verification">Driving Licence_Verification</MenuItem>
        <MenuItem value="NID_Verification">NID Verification</MenuItem>
        <MenuItem value="Email_Verification">Email Verification</MenuItem>
        <MenuItem value="Phone_Verification ">Phone Verification</MenuItem>
      </TextField>
      <Box style={{ display: 'flex', gap: '10px' }}>
        <Box style={{ flex: 1 }}>
          <TextField
            label="Label"
            variant="outlined"
            fullWidth
            size="small"
            className={`${classes.marginStyle} ${classes.inputStyle}`}
            value={label}
            onChange={e => setLabel(e.target.value)}
          />
        </Box>
        <Box style={{ flex: 1 }}>
          <TextField
            variant="outlined"
            select
            label="Type"
            size="small"
            fullWidth
            required
            value={type}
            onChange={e => setType(e.target.value)}
            className={`${classes.marginStyle} ${classes.inputStyle}`}>
            <MenuItem value="text">Text</MenuItem>
            <MenuItem value="image">Image</MenuItem>
          </TextField>
        </Box>
        <Box>
          <IconButton style={{ background: '#ddd' }} onClick={handleAdd}>
            <AddIcon />
          </IconButton>
        </Box>
      </Box>

      {/* {requirementRequiredFields.map((item, index) => (
        <Box style={{ display: 'flex', gap: '20px' }}>
          <Box style={{ flex: 1 }}>Label: {item.label}</Box>
          <Box style={{ flex: 1 }}>Type: {item.type}</Box>
        </Box>
      ))} */}

      <Box style={{ marginTop: '12px' }}>
        {requirementRequiredFields.map((item, index) => (
          <Chip
            key={index}
            color="info"
            style={{ margin: '0px 10px 10px 0px' }}
            icon={<CloseIcon />}
            label={`Label: ${item.label} , Type: ${item.type}`}
            onClick={i => deleteOne(item.label)}
            className={classes.chip}
          />
        ))}
      </Box>

      <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
        <FormControlLabel
          control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
          label="Status"
          labelPlacement="start"
        />
      </div>

      <div>{/* <Loding/> */}</div>
      <div className={classes.buttonMarginStyle}>
        {/* {loading ? <LinearProgress /> : null} */}

        <Button
          variant="contained"
          className={classes.buttonStyle}
          color="primary"
          disabled={loading}
          fullWidth
          onClick={onSubmit}>
          {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default RequirementAddEdit;
